import { render, staticRenderFns } from "./SingleMonitorView.vue?vue&type=template&id=4b579955&scoped=true"
import script from "./SingleMonitorView.vue?vue&type=script&lang=js"
export * from "./SingleMonitorView.vue?vue&type=script&lang=js"
import style0 from "./SingleMonitorView.vue?vue&type=style&index=0&id=4b579955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b579955",
  null
  
)

export default component.exports